Auth = require 'app/scripts/db/auth'
campaigns = require 'app/scripts/data/marketing-campaign-boards'
CopyBoardView = require 'app/scripts/views/board/copy-board-view'
{ getKey, Key } = require '@trello/keybindings'
PopOver = require 'app/scripts/views/lib/pop-over'
template = require 'app/scripts/views/templates/logged_in_public_board_banner'
{ trackUe } = require '@trello/analytics'
Util = require 'app/scripts/lib/util'
WarningBannerView = require 'app/scripts/views/header/warning-banner-view'
{ featureFlagClient } = require '@trello/feature-flag-client'

module.exports = class LoggedInPublicBoardBannerView extends WarningBannerView
  className: ->
    trelloForTeams = if @model.id in campaigns.TRELLO_FOR_TEAMS then 'trello-for-teams' else ''
    "header-banner mod-warning logged-in-public-board-banner #{trelloForTeams}"

  initialize: ->
    super

    @isHidden = false

    @makeDebouncedMethods 'render'
    @listenTo @model,
      'change:closed': @renderDebounced
      'change:prefs.permissionLevel': @renderDebounced
      'change:prefs.isTemplate': @renderDebounced

    @templateFlagEnabled = featureFlagClient.get('publicproduct.templates_v1', false)
    featureFlagClient.on 'publicproduct.templates_v1', false, (newVal) =>
      @templateFlagEnabled = newVal
      @renderDebounced()

  events:
    'keydown': 'keydownEvent'
    'click .js-close-banner': 'dismiss'
    'click .js-learn-more': 'trackHelp'
    'click .js-copy-board': 'copyBoard'

  dismissalKey: -> "logged-in-public-board-#{@model.get('id')}"

  dismiss: ->
    @isHidden = true
    Auth.me()?.dismissAd(@dismissalKey())
    @render()
    trackUe('public board', 'dismisses', 'reminder banner', '', '', 'by clicking close icon', { boardid: @model.get('id') })

  isDismissed: ->
    Auth.me()?.isAdDismissed(@dismissalKey())

  trackHelp: ->
    trackUe('public board', 'opens', 'help', '', '', 'by clicking link in reminder banner', { boardid: @model.get('id') })

  keydownEvent: (e) ->
    key = getKey(e)

    if key == Key.Enter
      if @$(e.target).hasClass('js-learn-more')
        @trackHelp()

      @$('.js-learn-more')
      return

  copyBoard: (e) ->
    Util.stop(e)
    boardNameInputValue = @model.get('name') if @templateFlagEnabled && @model.isTemplate()
    PopOver.toggle
      elem: @$(e.target).closest('.js-copy-board')
      view: new CopyBoardView({
        @templateFlagEnabled,
        @model,
        @modelCache,
        boardNameInputValue
      })

  render: ->
    # Hide the public board banner on templates, as templates have their own banner
    isTemplate = @model.isTemplate() && @templateFlagEnabled
    isVisible = !@isHidden && !@isDismissed() && @model?.isPublic() && !@model?.get('closed') && !isTemplate
    if isVisible
      trackUe('public board', 'displays', 'reminder banner', '', '', 'by viewing board', { boardid: @model.get('id') })

    @$el.toggleClass('hide', !isVisible)
    @$el.html template({
      isAdmin: @model?.owned(),
      trelloForTeams: @model.id in campaigns.TRELLO_FOR_TEAMS,
      isTemplate,
      isVisible
    })

    @
